var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"circle-group"},_vm._l((30),function(i){return _c('div',{key:i})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }